<template>
    <div>
        <!-- Modal -->
        <modal
            class="modal"
            v-if="showForm"
            :show.sync="showForm"
            headerClasses="justify-content-center"
        >
            <h3 v-if="!isUpdate">Add Indicator</h3>

            <el-form
                ref="form"
                :model="form"
                label-width="120px"
                v-if="showForm"
                class="form"
                ><div class="select input">
                    Indicator Type :
                    <el-select
                        v-model="customIndicatorForm.indicator_type"
                        placeholder="Select Indicator Type"
                        class="select__field "
                    >
                        <el-option
                            v-for="item in indicatorTypes"
                            :key="item.id"
                            :label="item.type"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="input">
                    Indicator ID :
                    <el-input
                        v-model="customIndicatorForm.indicator_id"
                        placeholder="Indicator ID"
                        class="input__field"
                    ></el-input>
                </div>
                <div class="input">
                    Indicator Name :
                    <el-input
                        v-model="customIndicatorForm.indicator_name"
                        placeholder="Indicator ID"
                        class="input__field"
                    ></el-input>
                </div>

                <div class="input">
                    Metric :
                    <el-input
                        v-model="customIndicatorForm.metric"
                        placeholder="Metric"
                        class="input__field"
                    ></el-input>
                    <!-- <div style="color: lightslategray">
                        If several metrics are to be entered, please use a comma
                        to separate them.
                    </div> -->
                </div>
            </el-form>
            <base-button @click="addIndicator()">Submit</base-button>
        </modal>
        <!-- Not Modal -->
        <!-- <h3>Reports</h3> -->
        <!-- <h3 v-if="isUpdate">Update Indicator</h3> -->
        <base-button
            size="sm"
            type="primary"
            @click="handleExport()"
            class="table__button"
            ><i class="el-icon-share"></i>Export</base-button
        >
        <el-form ref="form" :model="form" label-width="120px" class="form">
            <!-- <div class="input">
                Grant ID :
                <el-select
                    v-model="form.Grant_ID"
                    placeholder="Select Grant"
                    class="select__field"
                    clearable
                >
                    <el-option
                        v-for="item in grantsList"
                        :key="item.id"
                        :label="item.description"
                        :value="item.grantId"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                Applications :
                <el-select
                    v-model="form.Application"
                    placeholder="Select Application"
                    class="select__field"
                    :disabled="disabledForm.applications"
                    clearable
                >
                    <el-option
                        v-for="item in applicationsList"
                        :key="item.application_id"
                        :label="item.reference"
                        :value="item.application_id"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                Indicators :
                <el-select
                    v-model="indicatorForm.indicator"
                    placeholder="Select Indicator"
                    class="select__field"
                    :disabled="disabledForm.indicators"
                    clearable
                >
                    <el-option
                        v-for="item in indicatorsList"
                        :key="item.indicator"
                        :label="item.indicator"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div> -->
            <div class="input">
                Grant ID :
                <el-select
                    v-model="form.Grant_ID"
                    placeholder="Select Grant"
                    class="select__field filter-select mr-2"
                    clearable
                >
                    <el-option
                        v-for="item in grantsList"
                        :key="item.value"
                        :label="item.text + ` [` + item.total + `]`"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                Applications :
                <el-select
                    v-model="form.Application"
                    placeholder="Select Application"
                    class="select__field filter-select mr-2"
                    clearable
                >
                    <el-option
                        v-for="item in applicationsList"
                        :key="item.value"
                        :label="item.text + ` [` + item.total + `]`"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                Indicators :
                <el-select
                    v-model="indicatorForm.indicator"
                    placeholder="Select Indicator"
                    class="select__field filter-select mr-2"
                    clearable
                >
                    <el-option
                        v-for="item in indicatorsList"
                        :key="item.value"
                        :label="item.text + ` [` + item.total + `]`"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="input">
                Region :
                <el-input
                    v-model="form.Region"
                    placeholder="Region"
                    class="input__field"
                    disabled
                ></el-input>
            </div> -->
            <div class="select input">
                Region :
                <el-select
                    v-model="form.Region"
                    placeholder="Region"
                    class="select__field filter-select mr-2"
                    clearable
                >
                    <el-option
                        v-for="item in regionsList"
                        :key="item.value"
                        :label="item.text + ` [` + item.total + `]`"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="select input">
                Country :
                <el-select
                    v-model="form.Country"
                    placeholder="Country"
                    class="select__field filter-select mr-2"
                    clearable
                >
                    <el-option
                        v-for="item in countryList"
                        :key="item.value"
                        :label="item.text + ` [` + item.total + `]`"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
        </el-form>

        <div class="indicatorsform" v-if="0">
            <div class="indicatorsform__add">
                <el-form
                    ref="form"
                    :model="form"
                    label-width="120px"
                    class="form2"
                >
                    <div class="input">
                        Indicators :
                        <el-select
                            v-model="indicatorForm.indicator"
                            placeholder="Select Indicator Type"
                            class="select__field"
                            :disabled="disabledForm.indicators"
                        >
                            <el-option
                                v-for="item in indicatorsList"
                                :key="item.indicator"
                                :label="item.indicator"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input">
                        Baseline value :
                        <el-input
                            v-model="indicatorForm.Baseline_value"
                            placeholder="Baseline Value"
                            class="input__field"
                            :disabled="disabledForm.metrics"
                        ></el-input>
                    </div>
                    <div class="input">
                        Baseline Metric :
                        <el-select
                            v-model="indicatorForm.Baseline_metric"
                            placeholder="Baseline Metric"
                            class="select__field"
                            :disabled="disabledForm.metrics"
                        >
                            <el-option
                                v-for="item in baselineMetricsList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input">
                        <base-button
                            size="sm"
                            type="primary"
                            @click="openModal()"
                            class="input__field"
                            style="width: 225px !important"
                            >Add Custom<i class="el-icon-plus"></i
                        ></base-button>
                    </div>
                    <div class="input">
                        Final Value :
                        <el-input
                            v-model="indicatorForm.Final_value"
                            placeholder="Final Value"
                            class="input__field"
                            :disabled="disabledForm.metrics"
                        ></el-input>
                    </div>
                    <div class="input">
                        Final Metric :
                        <el-select
                            v-model="indicatorForm.Final_metric"
                            placeholder="Final Metric"
                            class="select__field"
                            :disabled="disabledForm.metrics"
                        >
                            <el-option
                                v-for="item in finalMetricsList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-form>
            </div>
            <div class="indicatorsform__button">
                <base-button
                    size="sm"
                    type="primary"
                    @click="handleAdd(indicatorForm)"
                    class="indicatorsform__buttons"
                    v-if="!isUpdate"
                    ><i class="el-icon-check"></i>Add</base-button
                >
                <base-button
                    size="sm"
                    type="info"
                    @click="handleUpdate(indicatorForm)"
                    class="indicatorsform__buttons"
                    v-if="isUpdate"
                    ><i class="el-icon-edit"></i>Update</base-button
                >
                <base-button
                    size="sm"
                    type="warning"
                    @click="handleClear()"
                    class="indicatorsform__buttons"
                    ><i class="el-icon-close"></i>Clear</base-button
                >
            </div>
        </div>

        <!-- <base-button @click="addIndicator()" v-if="!isUpdate"
            >Submit</base-button
        >
        <base-button @click="updateIndicator()" v-if="isUpdate"
            >Update</base-button
        > -->
        <!-- {{ tableData }}<br />
        {{ submitData }} -->
        <div class="table">
            <!-- {{tableData}} -->
            <el-table :data="tableData" style="width: 100%" class="table"  :default-sort = "{prop: 'indicator.indicatorCode', order: 'ascending'}">
                <el-table-column
                    prop="grant.grantName"
                    label="Grant Name"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="application.reference"
                    label="Application Name"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="indicator.indicatorCode"
                    label="Indicator ID"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="indicator.indicator"
                    label="Indicator Name"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="baselineValue"
                    label="Baseline Value"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="baselinemetric.name"
                    label="Baseline Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="finalValue"
                    label="Final Value"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="finalmetric.name"
                    label="Final Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <!-- <el-table-column label="" class="table__column">
                    <template slot-scope="scope">
                        <base-button
                            size="sm"
                            type="primary"
                            @click="handleExport(scope.$index, scope.row)"
                            class="table__button"
                            ><i class="el-icon-share"></i>Export</base-button
                        >
                    </template> </el-table-column
                >̥ -->

                <!-- <el-table-column
                    prop="indicator"
                    label="Indicator"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Baseline_metric"
                    label="Baseline Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Final_metric"
                    label="Final Metric"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Baseline_value"
                    label="Baseline Value"
                    class="table__column"
                    sortable
                >
                </el-table-column>
                <el-table-column
                    prop="Final_value"
                    label="Final Value"
                    class="table__column"
                    sortable
                >
                </el-table-column> -->
                <!-- <el-table-column label="" class="table__column">
                    <template slot-scope="scope">
                        <base-button
                            size="sm"
                            type="primary"
                            @click="handleEdit(scope.$index, scope.row)"
                            class="table__button"
                            :disabled="disabledindex == scope.$index"
                            >Edit<i class="el-icon-edit"></i
                        ></base-button>
                        <base-button
                            size="sm"
                            type="warning"
                            @click="handleDelete(scope.$index, scope.row)"
                            class="table__button"
                            >Delete<i class="el-icon-delete"></i
                        ></base-button>
                    </template> </el-table-column
                >̥ -->
                <!-- <el-pagination layout="prev, pager, next" :total="this.tableData.length" @current-change="setPage">
  </el-pagination> -->
            </el-table>
            <!-- <base-button
                            size="sm"
                            type="info"
                            @click="handleSubmit()"
                            class="table__button"
                            >Submit</base-button> -->
        </div>
        <div class="pagination-border">
            <base-pagination
                @input="getFilteredIndicators"
                class="pagination-no-border"
                v-model="pagination.current_page"
                :per-page="pagination.per_page"
                :total="pagination.total"
            >
            </base-pagination>
        </div>
    </div>
</template>
<style scoped lang="scss">
.pagination-border {
    background-color: #0000003d;
    padding: 10px;
}
.indicatorsform {
    display: flex;
    padding: 30px;
    background-color: white;
    // border:1px solid black;
    border-radius: 10px;
    box-shadow: inset;
    justify-content: space-around;
    align-items: center;
    margin: 10px;

    // &__add {
    //     display: flex;

    //     justify-content: flex-end !important;
    // }
    &__button {
        display: flex;
        flex-direction: row;
        padding: 10px;
        justify-content: center;
        align-items: center;

        // max-height:30px;
    }
    &__buttons {
        display: flex;
        min-width: 50px;
        max-height: 30px;
        padding: 20px;
        // border:1px solid black;
    }
    .form2 {
        justify-content: flex-end;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        max-width: 800px;
        .input {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            padding: 10px 20px;

            &__field {
                // max-width: 500px;
                max-width: 35vw;
            }
        }
        .select {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            padding: 10px;
            &__field {
                max-width: 30vw;
                border-color: 1px solid;
            }
        }
    }
}
.table {
    margin-top: 10px;
    &__button {
        margin: 20px !important;
    }
    &__column {
        text-align: center !important;
    }
}
.addIndicatorBtn {
    transform: translateY(-3px);
}
.alert {
    min-height: 25vh;
    color: rgba(34, 42, 66, 0.7);
    padding: 30px;
    &__button {
        margin: 10px;
        margin-left: auto;
    }
}

.form {
    //     display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-template-rows: repeat(3, 1fr);
    // grid-column-gap: 0px;
    // grid-row-gap: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;

    // gap:5;
    .input {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;

        &__field {
            // max-width: 500px;
            max-width: 30vw;
        }
    }
    .select {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        &__field {
            max-width: 30vw;
            border-color: 1px solid;
        }
    }
}

// .btn:not(:disabled):not(.disabled) {
//     margin: 10px;
// }
</style>
<script>
import {
    LogMonitoringService,
    GrantService,
    ApplicationService,
} from "@/services";
import { Table, TableColumn, Select, Option } from "element-ui";
import { Modal, BasePagination } from "src/components";
export default {
    name: "indicator-form",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BasePagination,
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        // Pagination
    },
    data() {
        return {
            showForm: false,
            showAlert: false,
            deleteID: "",
            isUpdate: false,
            tableData: [],
            submitData: [],
            page: 1,
            indicatorsList: [],
            baselineMetricsList: [],
            finalMetricsList: [],
            indicatorTypes: [],
            newIndicatorData: {},
            grantsList: [],
            applicationsList: [],
            regionsList: [],
            countryList: [],
            metricsList: [],
            region: [],
            region_id: "",
            country_id: "",

            disabledindex: -1,
            // For Pagination
            pagination: {
                current_page: 1,
                per_page: 5,
                total: 100,
            },
            customIndicatorm: {
                indicator_type: "",
                indicator_id: "",
                indicator_name: "",
                metric: "",
            },
            form: {
                Grant_ID: "",
                // ISO3(or country long name):"",
                ISO3: "",
                Country: "",
                Region: "",
                Indicator_ID: "",
                Indicator_name: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
                Application: "",
            },
            indicatorForm: {
                indicator: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
                custom: 0,
                final_metric_id: "",
                baseline_metric_id: "",
                application_indicator_id: "",
            },
            disabledForm: {
                applications: true,
                indicators: true,
                metrics: true,
            },
        };
    },
    methods: {
        setPage(val) {
            this.page = val;
        },
        onSubmit() {
            // console.log("submit!");
        },
        async handleUpdate(data) {
            var temp_tableData = {};
            temp_tableData = {
                indicator: this.indicatorForm.indicator,
                indicator_id: this.indicatorForm.indicator_id,
                Baseline_metric: data.Baseline_metric,
                Final_metric: data.Final_metric,
                Baseline_value: data.Baseline_value,
                Final_value: data.Final_value,
                grant_id: this.form.Grant_ID,
                application_id: this.form.Application,
                application_indicator_id:
                    this.indicatorForm.application_indicator_id,
                region_id: this.region_id,
                country_id: this.country_id,
                custom: data.custom,
                final_metric_id: this.indicatorForm.final_metric_id,
                baseline_metric_id: this.indicatorForm.baseline_metric_id,
            };
            await LogMonitoringService.updateApplicationIndicator(
                temp_tableData
            ).then((response) => {
                console.log("TableData : ", this.tableData);
                console.log("response : ", response);
                this.handleClear();
                this.getApplicationIndicators();
            });
        },
        openModal() {
            // this.getGrants();
            this.customIndicatorForm.indicator_id = "";
            this.customIndicatorForm.indicator_name = "";
            this.customIndicatorForm.metric = "";
            this.customIndicatorForm.indicator_type = "";
            this.showForm = !this.showForm;
            this.isUpdate = false;
        },
        async getApplicationIndicators() {
            await LogMonitoringService.getApplicationIndicators({
                applicationId: this.form.Application,
            }).then((response) => {
                console.log("Response in the getApplications : ",response)
                this.tableData = response.data.data;
                this.pagination.total=response.data.data.total;
                console.log("Pagination Total : ",this.pagination.total);
            });
            // this.getFilteredIndicators();
        },
        async getFilteredIndicators(
            // For pagination
            page
        ) {
            // For Pagination
            let page_to_get = page || this.pagination.current_page;

            await LogMonitoringService.getFilteredIndicators({
                page: page_to_get,
                per_page: this.pagination.per_page,
                grant: this.form.Grant_ID,
                application: this.form.Application,
                country: this.form.Country,
                regions: this.form.Region,
                indicator: this.indicatorForm.indicator,
            }).then((response) => {
                // alert("Inside filters")
                this.tableData = response.data.data.data;
                this.pagination.total=response.data.data.total;
                // console.log("TableData : ", this.tableData);

                // For Pagination
                // this.pagination = response.data.meta;
            });
        },
        async getAllIndicators() {
            await LogMonitoringService.getAllIndicators().then((response) => {
                this.tableData = response.data.data;
                this.pagination.total=response.data.data.total;
                // console.log("TableData : ", this.tableData);
            });
        },
        async getIndicators() {
            await LogMonitoringService.getIndicators().then((response) => {
                this.indicatorsList = response.data.data;
                console.log("this.indicatorsList : ", this.indicatorsList);
            });
        },
        async getIndicatorTypes() {
            await LogMonitoringService.getIndicatortypes().then((response) => {
                this.indicatorTypes = response.data.data;
            });
        },
        async addIndicator() {
            if (
                this.customIndicatorForm.indicator_id == "" ||
                this.customIndicatorForm.indicator_name == ""
            ) {
                // console.log("No data");
                return;
            }
            const data = {
                indicator_id: this.customIndicatorForm.indicator_id,
                indicator: this.customIndicatorForm.indicator_name,
                indicator_type_id: this.customIndicatorForm.indicator_type,
                metric: this.customIndicatorForm.metric,
            };
            this.newIndicatorData = data;
            this.indicatorForm.custom = 1;
            this.indicatorForm.indicator = this.newIndicatorData.indicator;
            this.indicatorForm.Baseline_metric = this.newIndicatorData.metric;
            this.indicatorForm.Final_metric = this.newIndicatorData.metric;
            this.showForm = false;
            this.disabledForm.metrics = false;
        },
        // async updateIndicator() {
        //     if (
        //         this.form.indicator_id == "" ||
        //         this.form.indicator_name == ""
        //     ) {
        //         console.log("No data");
        //         return;
        //     }
        //     const data = {
        //         id: this.form.id,
        //         indicator_id: this.form.indicator_id,
        //         indicator: this.form.indicator_name,
        //         indicator_type_id: this.form.indicator_type,
        //     };
        //     await LogMonitoringService.updateIndicator(data).then(
        //         (response) => {
        //             console.log(response);
        //             this.form.indicator_id = "";
        //             this.form.indicator_name = "";
        //             this.form.indicator_type = "";
        //             this.showForm = false;
        //             this.isUpdate = false;
        //             this.getIndicators();
        //             console.log("Updated indicator");
        //         }
        //     );
        // },
        async handleEdit(index, row) {
            // console.log("Index : ", index);
            // console.log("Row : ", row);
            this.getIndicators();
            // this.disabledindex = index;
            // this.indicatorForm.indicator = this.tableData[index].indicator;
            this.isUpdate = true;
            this.indicatorForm.indicator = row.indicatorId;
            this.indicatorForm.Baseline_value = row.baselineValue;
            this.indicatorForm.Baseline_metric = row.baselinemetric.name;
            this.indicatorForm.Final_value = row.finalValue;
            this.indicatorForm.Final_metric = row.finalmetric.name;
            this.indicatorForm.final_metric_id = row.finalMetricId;
            this.indicatorForm.baseline_metric_id = row.baselinemetric.id;
            this.indicatorForm.application_indicator_id = row.id;
            console.log("Row2 : ", row);

            // this.indicatorForm.custom = this.row.custom;
        },
        // async handleSubmit() {
        //     const data = {
        //         indicators: this.submitData,
        //         grant_id: this.form.Grant_ID,
        //         application_id: this.form.Application,
        //         region_id: this.region_id,
        //         country_id: this.country_id,
        //         // region_id:this.form.Region,
        //         // country_id:this.form.Country
        //     };
        //     await LogMonitoringService.addApplicationIndicator(data).then(
        //         (response) => {
        //             // console.log("Added applications : ", response);
        //         }
        //     );
        // },
        // async handleAdd(data) {
        //     console.log(data);
        //     var temp_tableData = {};
        //     if (this.indicatorForm.custom == 1) {
        //         temp_tableData = {
        //             indicator: this.indicatorForm.indicator,
        //             indicator_id: this.customIndicatorForm.indicator_id,
        //             Baseline_metric: data.Baseline_metric,
        //             Final_metric: data.Final_metric,
        //             Baseline_value: data.Baseline_value,
        //             Final_value: data.Final_value,
        //         };
        //         this.tableData.push(temp_tableData);
        //         this.handleClear();
        //         temp_tableData = {
        //             indicator_id: this.customIndicatorForm.indicator_id,
        //             indicator_type: this.customIndicatorForm.indicator_type,
        //             indicator: this.customIndicatorForm.indicator_name,
        //             Baseline_metric: data.Baseline_metric,
        //             Final_metric: data.Final_metric,
        //             Baseline_value: data.Baseline_value,
        //             Final_value: data.Final_value,
        //             custom: data.custom,
        //         };
        //         this.submitData.push(temp_tableData);
        //         this.indicatorForm.custom = 0;
        //     } else if (this.indicatorForm.custom == 0) {
        //         console.log("data.indicator : ",data);
        //         await LogMonitoringService.getIndicator(data.indicator).then(
        //             (response) => {
        //                 console.log(response);

        //                 temp_tableData = {
        //                     indicator_id: response.data.data.id,
        //                     indicator: response.data.data.indicator,
        //                     Baseline_metric: data.Baseline_metric,
        //                     Final_metric: data.Final_metric,
        //                     Baseline_value: data.Baseline_value,
        //                     Final_value: data.Final_value,
        //                 };
        //                 this.tableData.push(temp_tableData);
        //                 this.handleClear();
        //                 temp_tableData = {
        //                     indicator_id: response.data.data.id,
        //                     indicator: response.data.data.indicator,
        //                     Baseline_metric: data.Baseline_metric,
        //                     Final_metric: data.Final_metric,
        //                     Baseline_value: data.Baseline_value,
        //                     Final_value: data.Final_value,
        //                     custom: data.custom,
        //                 };
        //                 this.submitData.push(temp_tableData);
        //             }
        //         );
        //     }
        // },
        async handleAdd(data) {
            console.log(data, this.indicatorForm.custom);
            var temp_tableData = {};
            if (this.indicatorForm.custom == 1) {
                temp_tableData = {
                    indicator: this.customIndicatorForm.indicator_name,
                    indicator_id: this.customIndicatorForm.indicator_id,
                    indicator_code: this.customIndicatorForm.indicator_id,
                    indicator_type_id: this.customIndicatorForm.indicator_type,
                    Baseline_metric: data.Baseline_metric,
                    Final_metric: data.Final_metric,
                    Baseline_value: data.Baseline_value,
                    Final_value: data.Final_value,
                    grant_id: this.form.Grant_ID,
                    application_id: this.form.Application,
                    region_id: this.region_id,
                    country_id: this.country_id,
                    custom: this.indicatorForm.custom,
                };
                await LogMonitoringService.addApplicationIndicator(
                    temp_tableData
                ).then((response) => {
                    console.log("Added applications : ", response);
                    this.handleClear();
                    this.getApplicationIndicators();
                });
                this.indicatorForm.custom = 0;
            } else if (this.indicatorForm.custom == 0) {
                temp_tableData = {
                    indicator_id: this.indicatorForm.indicator,
                    indicator_code: this.indicatorForm.indicator,
                    // indicator: this.indicatorForm.indicator,
                    Baseline_metric: data.Baseline_metric,
                    Final_metric: data.Final_metric,
                    Baseline_value: data.Baseline_value,
                    Final_value: data.Final_value,
                    grant_id: this.form.Grant_ID,
                    application_id: this.form.Application,
                    region_id: this.region_id,
                    country_id: this.country_id,
                    custom: this.indicatorForm.custom,
                };
                await LogMonitoringService.addApplicationIndicator(
                    temp_tableData
                ).then((response) => {
                    console.log("Added applications : ", response);
                    this.handleClear();
                    this.getApplicationIndicators();
                });
                this.indicatorForm.custom = 0;
            }
        },
        handleClear() {
            const indicatorForm = {
                indicator: "",
                Baseline_value: "",
                Baseline_metric: "",
                Final_value: "",
                Final_metric: "",
            };
            this.indicatorForm = indicatorForm;
            this.disabledForm.metrics = true;
            this.disabledindex = -1;
            this.isUpdate = false;
        },
        // async handleDelete(index, row) {
        //     this.deleteID = row.id;
        //     this.showAlert = true;
        // },
        // async deleteIndicator() {
        //     await LogMonitoringService.deleteIndicator({
        //         id: this.deleteID,
        //     }).then((response) => {
        //         console.log(response);
        //         this.showAlert = false;
        //         this.getIndicators();
        //     });
        // },
        async getGrants() {
            await GrantService.all().then((response) => {
                // console.log(response);
                this.grantsList = response.data;
                // console.log("GrantList : ",this.grantsList);
            });
            // await GrantService.getGrantRegions().then((response) => {
            //     // console.log("GrantService.getGrantRegions : ", response);
            //     // this.regionsList = response.data.data;
            //     // console.log("GrantList : ",this.grantsList);
            // });
        },
        async handleExport() {
            await LogMonitoringService.exportApplicationIndicator({
                grant_id: this.form.Grant_ID,
                application_id: this.form.Application,
                country_id: this.form.Country,
                region_id: this.form.Region,
                indicator_id: this.indicatorForm.indicator,
            }).then((response) => {
                console.log(response);
                window.open(response.data.url);
            });
        },
        async getFilters() {
            // this.form.Region = "";
            // this.form.Country = "";
            await LogMonitoringService.getFilters({
                grant: this.form.Grant_ID,
                application: this.form.Application,
                country: this.form.Country,
                regions: this.form.Region,
                indicator: this.indicatorForm.indicator,
            }).then((response) => {
                console.log("Filters : ", response);
                this.grantsList = response.data.grant;
                this.applicationsList = response.data.application;
                this.indicatorsList = response.data.indicator;
                this.regionsList = response.data.regions;
                this.countryList = response.data.country;
            });
            this.getFilteredIndicators();
        },
    },
    mounted() {
        this.getGrants();
        this.getIndicators();
        this.getIndicatorTypes();
        this.getAllIndicators();
        this.getFilters();
    },
    watch: {
        "form.Grant_ID": async function (val) {
            // console.log(val);
            await ApplicationService.getApplications({
                grantId: this.form.Grant_ID,
            }).then((response) => {
                this.applicationsList = response.data.data;
                this.disabledForm.applications = false;
                this.form.Application = "";
                // console.log(
                //     "ApplicationService.getApplications : ",
                //     this.applicationsList
                // );
                this.getFilters();
            });
            // this.getFilters();

        },
        "form.Application": function (val) {
            // console.log(val);
            // console.log(this.applicationsList);
            // region_details.name
            // var region;
            // this.applicationsList.forEach((item) => {
            //     if (item.application_id === val) {
            //         region = item.region_details.name;
            //         // this.form.Region = item.region_details.name;
            //         // this.form.Country = item.countries[0].name;
            //         // this.region_id = item.region_id;
            //         // this.country_id = item.countries[0].country_id;
            //         this.disabledForm.indicators = false;
            //     }
            // });
            this.getFilters();
            this.getApplicationIndicators();
            this.getFilteredIndicators();
        },
        "indicatorForm.indicator": async function (val) {
            // console.log(val);
            if (this.indicatorForm.indicator == "") {
                this.getFilters();
                return;
            }
            await LogMonitoringService.getIndicatormetric({
                indicator_id: this.indicatorForm.indicator,
            }).then((response) => {
                // this.applicationsList = response.data.data;
                // console.log("Metrics : ", response);
                this.metricsList = response.data.data;
                this.baselineMetricsList = response.data.data;
                this.finalMetricsList = response.data.data;
                this.disabledForm.metrics = false;
                this.getFilters();
            });
            // this.getFilters();
        },
        "form.Region": function () {
            this.getFilters();
        },
        "form.Country": function () {
            this.getFilters();
        },
        tableData: function (val) {
            for (var i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].finalValue == null) {
                    this.tableData[i].finalValue =
                        this.tableData[i].finalTextValue;
                }
                if (this.tableData[i].baselineValue == null) {
                    this.tableData[i].baselineValue =
                        this.tableData[i].baselineTextValue;
                }
            }
        },
    },
};
</script>
